import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import { observer } from "mobx-react-lite";
import { joinClassNames } from "../../../utils";
import { useParams } from "react-router";
import AppStore from "../../../stores/User/AppStore";
import { Tooltip } from "antd";
import { set } from "mobx";
interface IndexListProps {
  contentValue: {
    type: string;
    name: string;
    id: string;
    click?: () => void;
  }[];
}
interface itemObj {
  [x: string]: any;
}
const IndexList: React.FC<IndexListProps> = (props) => {
  const contentRef: any = useRef(null);
  const params = useParams<{ projectId: string; appId: string }>();
  const project = AppStore.projects.find(
    (project) => project.id === +(params.projectId ?? 0)
  );
  const [sideCur, setSideCur] = useState<number>(0);
  const [toolTipInfo, setToolTipInfo] = useState<{
    top: number;
    left: number;
    title: string;
    visible: boolean;
  }>({
    top: 0,
    left: 0,
    title: "",
    visible: false,
  });
  const [itemDomList, setItemDomList] = useState<any[]>([]);
  const [formatItemArr, setFormatItemArr] = useState<any[]>([]);
  const [sideBar, setSideBar] = useState<any[]>([]);

  useEffect(() => {
    setItemDomList([]);
    const formatItem = props.contentValue.reduce((pre: any, cur, index) => {
      pre[cur.type]?.arr.length
        ? pre[cur.type].arr.push(cur)
        : (pre[cur.type] = { arr: [cur] });
      pre[cur.type].len = pre[cur.type].arr.length;
      return pre;
    }, {});
    
    setSideBar(Object.keys(formatItem).sort());

    const formatItemArr: any[] = [];
    for (const key in formatItem) {
      formatItemArr.push({ key, value: formatItem[key] });
    }

    let sumLen = 0;
    formatItemArr
      .sort((a: itemObj, b: itemObj) => (a.key < b.key ? -1 : 1))
      .map((item, index) => {
        if (index === 0) {
          sumLen = item.value.len;
          item.value.len = 0;
          return item;
        }
        let tmp = item.value.len;
        item.value.len = sumLen;
        sumLen += tmp;
        return item;
      });

    setFormatItemArr(formatItemArr);
    // const sideBar = Object.keys(formatItem).sort().map((item, index) => (
    //   <a
    //     className={joinClassNames([
    //       styles.side_bar_item,
    //       index === sideCur && styles.active,
    //     ])}
    //     key={item}
    //     onClick={() => {
    //       setSideCur(index);
    //       const len = formatItemArr.filter((i) => i.key === item)[0]?.value?.len;
    //       if (len) contentRef.current.scrollTop = len * 40;
    //       if (index === 0) contentRef.current.scrollTop = 0;
    //     }}
    //   >
    //     {item}
    //   </a>
    // ));

    const itemDomList: any[] = [];
    formatItemArr.forEach((item, index) => {
      item.value.arr.forEach((i: any) => {
        itemDomList.push(i);
        itemDomList[index].len = item.value.len;
        setItemDomList([...itemDomList]);
      });
    });
    console.log(itemDomList,"itemDomList");
  }, [props.contentValue]);

  useEffect(() => {
    if(itemDomList.length === 0) return;

    const domRect = itemDomList.find((item: any) => project && project.id === item.id)
    if(domRect) {
      setSideCur(domRect.type.charCodeAt() - 65);
    }else{
      setSideCur(0);
    }

    // setSideCur(
    //   itemDomList.length &&
    //     itemDomList
    //       .find((item: any) => project && project.id === item.id) 
    //       .type.charCodeAt() - 65
    // );
    if (contentRef) {
      contentRef.current.scrollTop =
        itemDomList.length &&
        itemDomList.find((item: any) => project && project.id === item.id)?.len *
          40;
    }
  }, [itemDomList.length]);

  const itemDom = itemDomList.map((item: any, index: number) => (
    <div
      className={joinClassNames([
        styles.content_item,
        item.id === project?.id && styles.active,
      ])}
      key={item.name}
      onClick={() => {
        item.click();
      }}
    >
      <span
        onMouseEnter={(e: any) => {
          if (e.target.clientWidth !== e.target.scrollWidth) {
            const domRect = e.target.getBoundingClientRect();
            setToolTipInfo({
              left: domRect.left,
              top: domRect.top,
              visible: true,
              title: `${item.name}`,
            });
          }
        }}
        onMouseLeave={() => setToolTipInfo({ ...toolTipInfo, visible: false })}
      >
        {item.name}
      </span>
      {/* )} */}
    </div>
  ));

  return (
    <div className={styles.container}>
      <div className={styles.side_bar}>
        {sideBar.map((item, index) => (
          <a
            className={joinClassNames([
              styles.side_bar_item,
              index === sideCur && styles.active,
            ])}
            key={item}
            onClick={() => {
              setSideCur(index);
              const len = formatItemArr.filter((i) => i.key === item)[0]?.value
                ?.len;
              if (len) contentRef.current.scrollTop = len * 40;
              if (index === 0) contentRef.current.scrollTop = 0;
            }}
          >
            {item}
          </a>
        ))}
      </div>
      <div className={styles.content} ref={contentRef}>
        {itemDom}
      </div>
      {toolTipInfo.visible && (
        <div
          className={styles.tool_tip}
          style={{
            top: toolTipInfo.top - 50 + "px",
            left: toolTipInfo.left + "px",
          }}
        >
          {toolTipInfo.title}
        </div>
      )}
    </div>
  );
};

export default observer(IndexList);
